import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-test"]
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["data-test"]
const _hoisted_4 = ["data-test"]
const _hoisted_5 = ["checked", "disabled"]
const _hoisted_6 = ["data-test"]
const _hoisted_7 = ["data-test"]

import { computed } from 'vue'

type Props = {
  dataTest?: string
  disabled?: boolean
  subtitle?: string
  title: string
  value?: boolean
}
type Emits = (e: 'input', value: boolean) => void

export default /*@__PURE__*/_defineComponent({
  __name: 'CoreSwitch',
  props: {
    dataTest: { default: 'core-switch' },
    disabled: { type: Boolean, default: false },
    subtitle: {},
    title: {},
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const valueHandler = (event: Event) => {
  const checked = (event.target as HTMLInputElement).checked
  emit('input', checked)
}

const buttonDataTest = computed(() => `${props.dataTest}-button`)
const subtitleDataTest = computed(() => `${props.dataTest}-subtitle`)
const titleDataTest = computed(() => `${props.dataTest}-title`)

const dataTestValue = computed(() => {
  return `${props.dataTest}-value-${props.value}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ disabled: _ctx.disabled }, "switch flex flex-col"]),
    "data-test": _ctx.dataTest
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "switch__title body--body-01-bold grow",
        "data-test": titleDataTest.value
      }, _toDisplayString(_ctx.title), 9, _hoisted_3),
      _createElementVNode("label", {
        class: "switch__button flex-none",
        "data-test": buttonDataTest.value
      }, [
        _createElementVNode("input", {
          class: "switch__button__input",
          type: "checkbox",
          checked: _ctx.value || undefined,
          disabled: _ctx.disabled,
          onInput: valueHandler
        }, null, 40, _hoisted_5),
        _createElementVNode("span", {
          "data-test": dataTestValue.value,
          class: "switch__button__slider"
        }, null, 8, _hoisted_6)
      ], 8, _hoisted_4)
    ]),
    (_ctx.subtitle)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "switch__subtitle body--auxiliary-01 text-core-neutral-cold-50",
          "data-test": subtitleDataTest.value
        }, _toDisplayString(_ctx.subtitle), 9, _hoisted_7))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})